var _style, _g, _path, _path2, _circle, _circle2, _g2, _g3, _path3, _path4, _path5, _defs, _path6, _g4, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoloGodBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 824 824.2",
    style: {
      enableBackground: "new 0 0 824 824.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#4A94FF;stroke-width:72;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st1{fill:#E6E6E6;}\n\t.st2{fill:#4A94FF;}\n\t.st3{fill:#3A3A3A;}\n\t.st4{fill:#555555;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{clip-path:url(#SVGID_00000120558157512249237820000007571798208175638148_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 411.1,
    y1: 36,
    x2: 36,
    y2: 788.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 412.9,
    y1: 36,
    x2: 788,
    y2: 788.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 36,
    y1: 788.2,
    x2: 788,
    y2: 788.2
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412,722.4c-207.3,0-342.2-231.9-347.8-241.7c-2.9-5.1-2.9-11.4,0-16.5c5.6-9.8,139.5-241.8,347.8-241.8 c207.3,0,342.2,231.9,347.8,241.7c2.9,5.1,2.9,11.5,0,16.6C754.1,490.6,618.2,722.4,412,722.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M228.7,472.4c0,101.3,82,183.4,183.3,183.4s183.4-82,183.4-183.3v-0.1c0-101.3-82.1-183.3-183.3-183.3 S228.7,371.2,228.7,472.4L228.7,472.4L228.7,472.4z"
  })), /*#__PURE__*/React.createElement("g", null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 411.9,
    cy: 472.4,
    r: 101
  })), /*#__PURE__*/React.createElement("g", null, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 411.9,
    cy: 472.4,
    r: 83.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M444.5,419.8c-19.5,0.5-35.2,16.1-35.2,34.1s15.5,33.4,35.2,34.1c19.5,0,35.2-16.1,35.2-34.1 S464,420.2,444.5,419.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M465.8,453.8c0-11.5-9.5-20.7-21.3-20.7s-21.3,9.3-21.3,20.7c0,11.5,9.5,20.7,21.3,20.7 C456.3,474.6,465.8,465.3,465.8,453.8z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M417.9,499.3c-10.4,0-18.8,8.2-18.8,17.8c0,9.6,8.3,17.7,18.8,17.7c10.6-0.3,18.8-8.1,18.8-17.7 C436.7,507.5,428.3,499.6,417.9,499.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M425.1,517.1c0-3.9-3.2-7-7.2-7s-7.2,3.2-7.2,7c0,3.9,3.2,7,7.2,7C421.8,524.1,425.1,521,425.1,517.1z"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M390.4,443.3c-4.3,0-8.1,3.5-8.1,7.6s3.6,7.6,8.1,7.6c4.6,0,8.1-3.4,8.1-7.6S394.8,443.3,390.4,443.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M363.3,498.2c-4.3,0-8.1,3.5-8.1,7.6s3.6,7.6,8.1,7.6c4.6,0,8.1-3.4,8.1-7.6S367.7,498.2,363.3,498.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M461.3,508.2c-4.3,0-8.1,3.5-8.1,7.6c0,4.1,3.6,7.6,8.1,7.6c4.6,0,8.1-3.4,8.1-7.6 C469.4,511.6,465.7,508.2,461.3,508.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 411.9,
    cy: 472.4,
    r: 83.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000158025432420674518950000012661320361578187950_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000158025432420674518950000012661320361578187950_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M365.1,399.4c-10.4-0.6-19.3,7-19.9,16.6s7.2,18.2,17.7,18.8c10.6,0.3,19.3-7,19.9-16.5 C383.4,408.7,375.5,400.3,365.1,399.4z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M371.2,417.6c0.2-3.9-2.8-7.2-6.8-7.5c-4-0.2-7.4,2.7-7.6,6.6s2.8,7.2,6.8,7.5 C367.6,424.4,371,421.5,371.2,417.6z"
  })))))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M301.7,412.1c0,23,18.6,41.7,41.7,41.7c23,0,41.7-18.6,41.7-41.7l0,0c0-23-18.6-41.7-41.7-41.7 C320.4,370.4,301.7,389.1,301.7,412.1L301.7,412.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoloGodBadge);
export default __webpack_public_path__ + "static/media/yolo_god_badge.6c87940d189ca0c6ff2ab3a102197b66.svg";
export { ForwardRef as ReactComponent };